/** True when the string is a valid or in-progress integer (allows a leading minus and scientific notation). */
export function isPartialInteger(raw) {
  return /^-?\d*([eE][-+]?\d*)?$/.test(raw);
}

/** True when the string is a valid or in-progress decimal (allows a leading minus, one point, and scientific notation). */
export function isPartialDecimal(raw) {
  return /^-?\d*\.?\d*([eE][-+]?\d*)?$/.test(raw);
}